import { useContext } from 'react';
import { LocaleContext } from '../context/LocaleProvider';

const useLocale = () => {
  return useContext(LocaleContext);
};

export default useLocale;
